import React from "react";
import CrudTable from "../components/CrudTable";

const columns = [
  { key: "name", label: "Manufacturer" },
  { key: "contact_person", label: "Contact" },
  { key: "email", label: "Email" },
  { key: "phone", label: "Phone" },
  { key: "city", label: "City" },
  { key: "inventory_available", label: "Inventory" },
  { key: "contract_status", label: "Contract", status: true },
];
const formFields = [
  { name: "name", label: "Company Name", required: true },
  { name: "contact_person", label: "Primary Contact" },
  { name: "email", label: "Email", required: true, type: "email" },
  { name: "phone", label: "Phone", required: true },
  { name: "city", label: "City", required: true },
  { name: "gst", label: "GST" },
  { name: "website", label: "Website" },
  { name: "address", label: "Address", wide: true },
  { name: "inventory_available", label: "Inventory Available", type: "number", default: 0 },
  { name: "contract_status", label: "Contract Status", type: "select", default: "active",
    options: [{ value: "active", label: "Active" }, { value: "paused", label: "Paused" }, { value: "terminated", label: "Terminated" }] },
];

export default function Manufacturers() {
  return <CrudTable title="Manufacturers" description="Battery vendors supplying the RushGro network." endpoint="/manufacturers" columns={columns} formFields={formFields} />;
}
